import { useState, useEffect } from "react";

const MustacheFilled = ({ selected = false, filled = false }) => {
  return (
    <svg id="Capa_1" viewBox="0 0 490.4 490.4">
      <path
        className={
          "stroke-[20px] " +
          (filled
            ? selected
              ? "fill-primary stroke-primary"
              : "fill-black stroke-black"
            : selected
            ? "fill-white stroke-primary"
            : "fill-white stroke-black")
        }
        d="M481,215.9c-1.4,1.1-2.9,2.2-4.5,3.3l0,0l0,0c-7.9,5.1-18.5,9.2-32.8,9.9c-41.3,2.1-77.6-68.9-135.5-66
		c-14.8,0.7-35.3,4.3-63,31.8c-27.7-27.6-48.1-31.1-63-31.8c-57.9-2.9-94.2,68.1-135.5,66c-14.3-0.7-25-4.8-32.8-9.9l0,0l0,0
		c-1.6-1.1-3.1-2.2-4.5-3.3c-13.2-8.4-8.9,7.2-8,10.3c12.1,37.3,43.3,97.1,119.7,100.9c60.8,3.1,102.7-24.7,124.1-55.4
		c21.4,30.6,63.3,58.4,124.1,55.4c76.4-3.8,107.6-63.6,119.7-100.9C490,223.1,494.3,207.5,481,215.9z"
      />
    </svg>
  );
};

const Mustache = (props) => {
  const [mustacheArr, setMustacheArr] = useState([]);
  const arr = [];
  const kindArr = props.kind.split('_');
  const kind = kindArr[0];
  useEffect(() => {
    switch (kind) {
      case "slodkie":
        arr.push(true, true, true);

        break;
      case "polslodkie":
        arr.push(true, true, false);

        break;
      case "polwytrawne":
        arr.push(true, false, false);

        break;
      case "wytrawne":
        arr.push(false, false, false);

        break;
    }
    setMustacheArr(arr);
  }, []);

  return (
    <div className="flex space-x-1">
      {mustacheArr.map((item) => (
        <div className="w-6">
          <MustacheFilled
            selected={props.selected}
            filled={item}
          ></MustacheFilled>
        </div>
      ))}
    </div>
  );
};
export default Mustache;
